// The three-way control of docs/MRCS/dnd-5e.md §5.1, on the attack form, an area's save and the dice bag, shown only
// when the system's dice take it. It says what will decide the throw, reasons beside it; the server decides again.
import { advantageText, decideAdvantage, type AdvantageAsk, type AdvantageSource } from '@dragons-table/vtt-shared';
import { BTN } from '../ui';

const WAYS: ReadonlyArray<{ ask: AdvantageAsk; label: string }> = [{ ask: 'disadvantage', label: 'Disadvantage' }, { ask: 'normal', label: 'Normal' }, { ask: 'advantage', label: 'Advantage' }];

/** `value`: the form's own word, null with none. `known`: the reasons the table has before it (a ticked situation). */
export function AdvantageControl({ id, label, value, known = [], onChange }: {
  id: string; label: string; value: AdvantageAsk | null; known?: readonly AdvantageSource[]; onChange: (ask: AdvantageAsk) => void;
}) {
  const facts = decideAdvantage(known, value);
  const now = facts?.result ?? 'normal';
  return (
    <div role="group" aria-label={label} className="flex flex-wrap items-center gap-1" data-testid={`advantage-${id}`}>
      {WAYS.map((w) => (
        <button key={w.ask} type="button" className={`${BTN}${now === w.ask ? ' bg-amber-700/40' : ''}`} aria-pressed={now === w.ask} data-testid={`advantage-${id}-${w.ask}`} onClick={() => onChange(w.ask)}>{w.label}</button>
      ))}
      {facts && <span className="text-stone-400" data-testid={`advantage-${id}-why`}>{advantageText(facts)}</span>}
    </div>
  );
}
